<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="goBack()" class="back-btn">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Resultado final</span>
</mat-toolbar>

<div class="fr-wrapper">
  <!-- ── Hero ─────────────────────────────────────────────── -->
  <div class="fr-hero">
    <div class="fr-hero-bg"></div>
    <div class="fr-hero-content">
      <div class="fr-hero-icon">
        <mat-icon>workspace_premium</mat-icon>
      </div>
      <h1 class="fr-hero-title">Resultado oficial</h1>
      <p class="fr-hero-sub">Registra el campeón y el pichichi del torneo</p>
    </div>
  </div>

  <!-- ── Body ─────────────────────────────────────────────── -->
  <div class="fr-body">
    @if (finalResult) {
      <!-- Champion -->
      <div class="section-label">Campeón del mundo</div>
      <div class="fr-card">
        <div class="fr-card-preview">
          @if (finalResult.teamId) {
            <img class="preview-flag" [src]="getTeamFlag()" alt="" />
          } @else {
            <div class="preview-placeholder">
              <mat-icon>emoji_events</mat-icon>
            </div>
          }
        </div>
        <div class="fr-card-field">
          <mat-form-field appearance="outline" class="fr-field">
            <mat-label>Selecciona el equipo</mat-label>
            <mat-select [(ngModel)]="finalResult.teamId">
              @for (team of teams; track team) {
                <mat-option class="teams-select" [value]="team._id">
                  <img [src]="team.flag" /> {{ team.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Pichichi -->
      <div class="section-label">Pichichi</div>
      <div class="fr-card">
        <div class="fr-card-preview">
          @if (pichichiTeamId) {
            <img class="preview-flag" [src]="getPichichiTeamFlag()" alt="" />
          } @else {
            <img
              class="preview-pichichi"
              src="assets/imgs/pichichi.png"
              alt="Pichichi"
            />
          }
        </div>
        <div class="fr-card-field fr-card-field--stack">
          <mat-form-field appearance="outline" class="fr-field">
            <mat-label>Equipo del jugador</mat-label>
            <mat-select
              [ngModel]="pichichiTeamId"
              (ngModelChange)="onPichichiTeamChange($event)"
            >
              @for (team of teams; track team) {
                <mat-option class="teams-select" [value]="team._id">
                  <img [src]="team.flag" /> {{ team.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (pichichiPlayersLoading) {
            <div class="players-loading">
              <mat-icon class="spin">autorenew</mat-icon>
              <span>Cargando jugadores…</span>
            </div>
          }

          @if (!pichichiPlayersLoading && pichichiTeamId) {
            <mat-form-field appearance="outline" class="fr-field">
              <mat-label>Jugador</mat-label>
              <mat-select [(ngModel)]="finalResult.pichichi">
                @for (player of pichichiPlayers; track player) {
                  <mat-option [value]="player._id">{{
                    player.name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>

      <!-- Save CTA -->
      <button class="cta-btn" (click)="update()">
        <mat-icon>save</mat-icon>
        Guardar resultado
      </button>
    }
  </div>
</div>

<block-ui></block-ui>
